import React, { useCallback, useContext, useEffect, useState } from 'react'
import { RoleUserPicker } from './RoleUserPicker'
import { Row } from 'reactstrap'
import { Button, Col, Input, Modal, Select } from 'antd'
import AwsServerService from '../../common/util/AwsServerService'
import AppContext from '../../Context/AppContext'
import { Socket } from '../../Context/AppActions'
import "bootstrap/dist/css/bootstrap.min.css";
import TreeStructuralRole from './HierarchicalDropdown'
import HierarchicalDropdown from './HierarchicalDropdown'
import { useSelector } from 'react-redux'
import Config from "../../config.json";
import axios from "axios";

const RolesPopupData = ({ setprojectRoleObject, onSaveCallBack, projectRoleObject, openRoleModal, onCloseRoleModal, Deal_Id, TypeOpDropdown, ClientName,
    jobData, allRoles, ModuleContacts,setOpenRoleMadal
 }) => {
    console.log("projectRoleObject",projectRoleObject);
    
    const AppData = useContext(AppContext);
    const { dispatch, state } = AppData || {};
    const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals);
    const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
    const [DealChange, setDealChange] = useState("");
    let externalUserList = ["Accounts", "Vendors", "Contacts"]
    const [UserType, setUserType] = useState(null)
    const [clearSearchValue,setclearSearchValue]=useState(false)
    const [ErrorStatus, setErrorStatus] = useState({
        roleTypeError: "",
        roleError: "",
        userError: "",
        DealAndClientError: ""
    })
    console.log("ErrorStatus",ErrorStatus);
    const [RoleTypeList, setRoleTypeList] = useState([{
        roleType_Name: "Deal role",
        roleType_value: "Deal"
    }, {
        roleType_Name: "Account role",
        roleType_value: "Account"
    }, {
        roleType_Name: "Vendor role",
        roleType_value: "Vendor"
    }, {
        roleType_Name: "Internal",
        roleType_value: "Zoho"
    },
    {
        roleType_Name: "Other Contact",
        roleType_value: "Other"
    },
    ]);
    const [userListModules, setUserListModule] = useState(["All"]);
    const [ModuleData, setModuleData] = useState([])
    const [searchValue1, setSearchValue1] = useState("");
    const [userExcludeModuleList, setUserExcludeModuleList] = useState(["Roles"])
    const [originalRoleData, setOriginalRoleData] = useState({});
    const onUserTypeChange = (value) => {
        setErrorStatus({})
        setUserType(value);
        value == "All" && setUserExcludeModuleList(["Roles"])
        setUserListModule([value])
        setprojectRoleObject({
            "RoleId": "",
            "UserId": "",
            "UserType": "",
        })
    };

    const onRoleChange = (value, option) => { 
        setErrorStatus({})
        let obj = { ...projectRoleObject }
        if (value) {
            obj["RoleId"] = value.split("_")[1];
        } else {
            obj["RoleId"] = "";
        }
        setprojectRoleObject(obj);
    }
    const onDealChange = (value, option) => {
        setErrorStatus({})
        let obj = { ...projectRoleObject }
        if (value) {
            obj["ProjectId"] = value;
        } else {
            obj["ProjectId"] = "";
        }
        setDealChange(value)
        setprojectRoleObject(obj);
    }
    const onUserChange = (value, option) => {
         
        let obj = { ...projectRoleObject }
        obj['UserId'] = value;
        obj['UserType'] = UserType
        setprojectRoleObject(obj);
        setclearSearchValue(true)
    }
    const findUserInContacts = (moduleContacts, UserId) => {
        for (const Type of Object.keys(moduleContacts)) {
            const foundUser = moduleContacts[Type]?.find((a) => a.id === UserId);
            if (foundUser) {
            return { ...foundUser, Type };
            }
        }
        return null;
    };

    const foundUserName = (UserId) => {
        const moduleContacts = ModuleContacts || {};
        const foundUser = findUserInContacts(moduleContacts, UserId);

        if (!foundUser) return null;

        const { Type, Contact_Type } = foundUser;

        let displayName = '';

        if (Type === 'Account' || Type === 'Other' || Contact_Type === 'Account' || Contact_Type === 'Other' || Contact_Type === 'Vendor') {
            displayName = foundUser.Full_Name;
        } else if (Type === 'Zoho' || Type === 'Internal') {
            displayName = foundUser.name;
        } else {
            displayName = foundUser.Full_Name || foundUser.name || 'Unknown User';
        }

        return displayName;
    };

    const addToDealActivity = (action, payload) =>{ 
        let actionPerformed = action == true ? "Updated" : "Added";
        const role = allRoles.find((r) => r?.ROWID == payload?.RoleId);
        const userName = foundUserName(payload?.UserId);
        let finalMessage;
        if(action){
            const oldRole = allRoles.find((r) => r?.ROWID == originalRoleData?.RoleId);
            const oldUserName = foundUserName(originalRoleData?.UserId);
            if(originalRoleData?.RoleId != payload?.RoleId && originalRoleData?.UserId != payload?.UserId){
                // finalMessage = `${actionPerformed ?? 'UNKNOWN'}___` + ` Updated role from "${oldRole?.RoleName}" to "${role?.RoleName}" for ${oldUserName} to ${userName}`
                finalMessage = `${actionPerformed ?? 'UNKNOWN'}___` + ` Role Updated <br/> "${oldRole?.RoleName}" ➡️ "${role?.RoleName}" for ${oldUserName} ➡️ ${userName}`
            } else if(originalRoleData?.RoleId != payload?.RoleId){
                finalMessage = `${actionPerformed ?? 'UNKNOWN'}___` + ` Role Updated <br/> "${oldRole?.RoleName}" ➡️ "${role?.RoleName}" for ${userName}`
            } else if(originalRoleData?.UserId != payload?.UserId){
                finalMessage = `${actionPerformed ?? 'UNKNOWN'}___` + ` User Updated <br/> ${oldUserName} ➡️ ${userName} for role "${role?.RoleName}"`
            } else {
                finalMessage = `${actionPerformed ?? 'UNKNOWN'}___` + ` Role Updated <br/> "${role?.RoleName}" for ${userName}`
            }
        } else {
            finalMessage = `${actionPerformed ?? 'UNKNOWN'}___` + ` Assigned Role <br/> "${role?.RoleName}" ➡️ ${userName}`
        }
        const backendUrl = Config.backend_aws_server_url + "catalyApi/workdrive";
        let notesconfig = {
            Type: 'Create',
            method: 'POST',
            url: `https://www.zohoapis.com/crm/v2/Deals/${jobData.id}/Notes`,
            headers: { "Authorization": localStorage.getItem('token') },
            data: [
                {
                    Note_Title: `${finalMessage}`,
                    Note_Content: `${finalMessage}`,
                }
            ]
        }
        console.log("notesconfig:-",notesconfig?.data)
        axios.post(backendUrl, { config: notesconfig })
            .then(res => {
            console.log("Note created successfully:", res.data);
            })
            .catch(error => {
                alert(`Error creating notes for Activity : ${error}`);
            });
    }
    const handleProjectRolesave = () => { 
        // Ensure projectRoleObject is defined
        if (!projectRoleObject) {
            console.error("Error: projectRoleObject is undefined");
            return;
        }
        // Create payload
        const payload = {
            RoleId: projectRoleObject["RoleId"],
            UserId: projectRoleObject["UserId"],
            ProjectId: Deal_Id || DealChange || projectRoleObject['ProjectId'],
            UserType: projectRoleObject["UserType"]
        };
        // Validation checks
        let newErrors = {
            roleError: !payload.RoleId ? "error" : "",
            userError: !payload.UserId ? "error" : "",
            DealAndClientError:payload.UserType=='Zoho'?"": !payload.ProjectId ? "error" : "",
            roleTypeError: !payload.UserType ? "error" : "",
        };
        // If any validation fails, update state and stop execution
        if (Object.values(newErrors).some((error) => error !== "")) {
            setErrorStatus(newErrors);
                return;
        }else{
            setErrorStatus({
                roleTypeError: "",
                roleError: "",
                userError: "",
                DealAndClientError: ""
            });
        }
        let isEdit =false;
        if (openRoleModal.type=='edit' && openRoleModal.data["ROWID"]) {
            isEdit = true;
            payload["ROWID"] = openRoleModal.data["ROWID"];
        }
        // API Call
        AwsServerService.CrudServiceHandler({
            method: isEdit ? "PUT" : "POST",
            data: payload,
            route: "USERROLES"
        })
            .then((res) => {
                if (res) {
                     ;
                    setOpenRoleMadal()
                    payload["ROWID"] = res?.data?.[0]?.insertId;
                    addToDealActivity(isEdit, payload)
                    if (Deal_Id) {
                        dispatch(Socket({ trigger: "Refresh_Module", data: { module: "DEAL_DASH_USERROLE", id: Deal_Id } }));
                    }

                    // Reset form values
                    setprojectRoleObject({
                        RoleId: "",
                        UserId: "",
                        UserType: ""
                    });
                    setUserType(null);
                    onCloseRoleModal();
                    onSaveCallBack && onSaveCallBack(res);
                }
            })
            .catch((e) => {
                console.error("API Error:", e);
            });
    };
    const ClearAllData = () => {
        setUserListModule([])
        setUserType(null);
        setprojectRoleObject({
            "RoleId": "",
            "UserId": "",
            "UserType": "",
        })
    }
    useEffect(() => {
        console.log("openRoleModal?.data",openRoleModal?.data);
        
        openRoleModal?.open == false && ClearAllData()
        if(openRoleModal?.type == 'edit'){
            setUserType(openRoleModal?.data?.UserType)
            setUserListModule([openRoleModal?.data?.UserType])
            setOriginalRoleData(projectRoleObject); 
        } else {
            setOriginalRoleData({});
        }
        // openRoleModal?.type == 'edit' ? setUserListModule([openRoleModal?.data]) : setUserListModule(["All"]);
        // console.log("openRoleModal?.type", openRoleModal?.type, UserType);

    }, [openRoleModal])


    useEffect(() => {
        console.log("userListModules", userListModules);

        // Check if ModuleData is empty
        if (ModuleData.length === 0) {
            const fetchModules = async () => {
                try {
                    // Fetch the MODULES data
                    const res = await AwsServerService.CrudServiceHandler({
                        method: "GET",
                        data: "",
                        route: "MODULES",
                    });

                    // Map the response to the desired structure
                    const ModulesData = res.data.map((item) => ({
                        ModuleDisplayName: item?.ModuleDisplayName,
                        ModuleApiName: item?.ModuleApiName,
                        ApiPrimaryField: item?.ApiPrimaryField,
                        ApiNameField: item?.ApiNameField,
                    }));
                    externalUserList = []
                    ModulesData.map((item) => externalUserList.push(item?.ModuleDisplayName))
                    // Set the ModuleData state
                    setModuleData(ModulesData);
                } catch (error) {
                    console.error("Error fetching modules:", error);
                }
            };

            fetchModules(); // Call the async function
        }
    }, [userListModules, ModuleData]);
    console.log("projectRoleObject In popupModule", projectRoleObject);
    console.log("moduleContacts",moduleContacts);

    const getAssociatDropdown = useCallback(() => {
        if (UserType !== "Deal") {
            return (
                Object.keys(moduleContacts || {})
                    .flatMap((Type) =>
                        (moduleContacts[Type] || [])
                            .filter((subgroupData) => Type === UserType) // Filter matching UserType
                            .map((subgroupData) => {
                                const subgroupKey = subgroupData[`${Type}_Name`]?.id;
                                const isTypeNamePresent = subgroupData[`${Type}_Name`]?.name || "Unknown";
                                return subgroupKey ? (
                                    <Select.Option key={subgroupKey} value={subgroupKey}>
                                        {isTypeNamePresent}
                                    </Select.Option>
                                ) : null; // Prevent rendering invalid options
                            })
                    )
                    .filter(Boolean) // Remove null values
            );
        } else {
            return (
                AllDeals?.map((subgroupData) => {
                    const subgroupKey = subgroupData["Deal_Name"];
                    const isTypeNamePresent = subgroupData["Deal_Name"] || "Unknown";
                    return subgroupKey ? (
                        <Select.Option key={subgroupKey} value={subgroupKey}>
                            {isTypeNamePresent}
                        </Select.Option>
                    ) : null;
                }).filter(Boolean) // Remove null values
            );
        }
    }, [UserType, moduleContacts, AllDeals]); // Added missing dependencies
    
    
    return (
        <div>
            <Modal
                className='Role-Modal'
                destroyOnClose={true}
                title={openRoleModal?.type == "edit" ? "Edit User Role" : "Create User Role"}
                onCancel={onCloseRoleModal}
                open={openRoleModal?.module == "userroles" && openRoleModal?.open}
            >
                <div className='Role-Modal-Body Custom-Input-Wrapper'>
                    <div className="client-contact-role flex">
                        <Row className="Input-Group mb-3 mr-0 ml-0">
                            <Col>
                                <span className="labeltext">
                                    Select Role Type
                                </span>
                                {/* <Select
                                    placeholder={"Select User Type"}
                                    value={UserType}
                                    style={{ width: "100%", height: "auto" }}
                                    onChange={e => {
                                        onUserTypeChange(e)
                                    }}
                                    //mode='multiple'
                                    status={ErrorStatus?.roleTypeError?'error':''}>
                                    {RoleTypeList?.map((roleType, i) => {
                                        return <Select.Option
                                            key={roleType.roleType_Name}
                                            value={roleType.roleType_value}
                                            label={roleType.roleType_Name}
                                            children={roleType.roleType_Name}
                                            icon={<></>} />
                                    })}
                                </Select> */}
                                <Select
    placeholder={"Select User Type"}
    value={UserType}
    style={{ width: "100%", height: "auto" }}
    onChange={e => {
                                        onUserTypeChange(e);
                                    }}
                                    status={ErrorStatus?.roleTypeError ? 'error' : ''}
                                >
                                    {[...(RoleTypeList || [])]
                                        .sort((a, b) => a.roleType_Name.localeCompare(b.roleType_Name))
                                        .map((roleType, i) => (
                                            <Select.Option
                                                key={roleType.roleType_Name}
                                                value={roleType.roleType_value}
                                                label={roleType.roleType_Name}
                                                children={roleType.roleType_Name}
                                                icon={<></>}
                                            />
                                        ))}
                                </Select>

                                {/* {ErrorStatus?.roleTypeError?<div className='error-text'>Please select this field</div>:""} */}
                            </Col></Row>

                        {((UserType == "Account" || UserType == "Vendor" || UserType == "Deal") && (!TypeOpDropdown)) &&
                            <Row className="Input-Group mb-3 mr-0 ml-0">
                                <Col>
                                    <span className="labeltext">
                                        Select {UserType}
                                    </span>
                                    <Select
                                        showSearch
                                        searchValue={searchValue1}
                                        status={ErrorStatus?.DealAndClientError?'error':''}
                                        placeholder={`Select ${UserType}`}
                                        value={projectRoleObject.ProjectId}
                                        style={{ width: "100%", height: "auto" }}
                                        onChange={(e) => {
                                            onDealChange(e);
                                        }}
                                        dropdownRender={(menu) => (
                                            <div>
                                                {/* Static search box that controls Select's search */}
                                                <Input
                                                    placeholder="Search..."
                                                    value={searchValue1}
                                                    onChange={(e) => setSearchValue1(e.target.value)}
                                                    autoFocus
                                                    style={{ marginBottom: 8, width: "100%" }}
                                                />
                                                {menu}
                                            </div>)}
                                    >
                                        {getAssociatDropdown()}
                                    </Select>
                                    {/* {ErrorStatus?.DealAndClientError?<div className='error-text'>Please select this field</div>:""} */}

                                </Col>
                            </Row>
                        }
                        <Row className="Input-Group mb-3 mr-0 ml-0">
                            <Col>
                                <span className="labeltext">
                                    Select Role
                                </span>
                                <RoleUserPicker key={1}
                                    placeholder={"Select Role"}
                                    onChange={onRoleChange}
                                    filter={UserType}
                                    groupFromProps={["Roles"]}
                                    value={projectRoleObject['RoleId'] ? "Roles_" + projectRoleObject['RoleId'] : null}
                                    isRole={true}
                                    ErrorStatus={ErrorStatus?.roleError?'error':''} />
                                
                            </Col></Row>
                            {/* {ErrorStatus?.roleError?<div className='error-text mb-3'>Please select this field</div>:""} */}
                        <Row className="Input-Group mb-3 mr-0 ml-0">
                            <Col>
                                <span className="labeltext">
                                    Select {UserType} Role Assignee
                                </span>
                                <HierarchicalDropdown
                                    GroupName={userListModules}
                                    filter={UserType != "Deal" ? projectRoleObject["ProjectId"] : null}
                                    handleChangeUser={onUserChange}
                                    selectedUsers={projectRoleObject['UserId']}
                                    placeholder={UserType?`Select ${UserType} Role Assignee`:"Select Assignee"}
                                    ErrorStatus={ErrorStatus.userError?'error':""}
                                    clearSearchValue={clearSearchValue}
                                    setclearSearchValue={setclearSearchValue}
                                />
                                
                            </Col></Row>
                        {TypeOpDropdown &&
                            <Row className="Input-Group mb-3 mr-0 ml-0">
                                <Col>
                                    <span className="labeltext">
                                        Select {TypeOpDropdown}
                                    </span>
                                    <Select
                                        status={ErrorStatus?.DealAndClientError?'error':''}
                                        placeholder={ClientName || Deal_Id}
                                        value={ClientName || Deal_Id}
                                        style={{ width: "100%", height: "auto" }}
                                        onChange={e => {
                                            onUserTypeChange(e)

                                        }}
                                        disabled>

                                    </Select>
                                    {/* {ErrorStatus?.DealAndClientError?<div className='error-text'>Please select this field</div>:""} */}
                                </Col></Row>
                        }
                        <Row className='Button-Group-Class mr-0 ml-0 d-flex' style={{flexWrap:"nowrap"}}>
                            {(ErrorStatus?.DealAndClientError || ErrorStatus?.roleError || ErrorStatus?.roleTypeError || ErrorStatus?.userError) ?<div className='error-text' style={{width:"79%"}}>Please select All fields</div>:""}
                            <Button style={{ width: "auto", padding: "7px" }}
                                onClick={() => {
                                    ClearAllData()
                                }}
                            >Clear</Button>
                            <Button style={{ width: "auto", padding: "7px" }} type='primary'
                                onClick={() => { handleProjectRolesave() }}
                            >{projectRoleObject?.ROWID ? "Update" : "Save"}</Button>
                        </Row>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default RolesPopupData
